import styled from '@emotion/styled';
import { Flex } from 'antd';

export const ColumnTitle = styled.span`
  font-size: 12px;
  line-height: 19px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const MemberCell = styled(Flex)`
  min-width: 220px;
`;

export const Avatar = styled(Flex)`
  width: 36px;
  height: 36px;
  flex-shrink: 0;
  border-radius: 50%;
  background: ${({ theme }) => theme.colors.blueLight};
  color: ${({ theme }) => theme.colors.link};
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
`;

export const Name = styled.span`
  font-weight: 600;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.black};
`;

export const Email = styled.span`
  font-size: 12px;
  line-height: 18px;
  color: ${({ theme }) => theme.colors.grayDark};
`;

export const MutedText = styled.span`
  font-size: 13px;
  color: ${({ theme }) => theme.colors.gray};
`;

export const RightsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px 24px;
`;

export const RightRow = styled(Flex)`
  width: 100%;
`;

export const RightLabel = styled.span`
  line-height: 22px;
  color: ${({ theme }) => theme.colors.black};
`;

export const ModalHint = styled.span`
  font-size: 13px;
  line-height: 20px;
  color: ${({ theme }) => theme.colors.grayDark};
`;
